export default "__VITE_ASSET__1KcTos9T__"